<template>
  <div class="content">
    <div id="pagination" class="div">
      <div class="pagination-wrapper">
        <div v-if="items > 1 && items < 5">
          <span
            class="pagination"
            v-for="(i, j) in page"
            :key="i"
            @click="changePage(j)"
            :class="{ active: j == pagination }"
          ></span>
        </div>
        <div v-else-if="items > 1">
          <span
            class="pagination"
            @click="changePage(bullets)"
            :class="{ active: bullets == pagination, xsbullet: bullets > 0 }"
          >
          </span>
          <span
            class="pagination"
            @click="changePage(bullets + 1)"
            :class="{
              active: bullets + 1 == pagination,
              sbullet: bullets + 1 > 1,
            }"
          >
          </span>
          <span
            class="pagination"
            @click="changePage(bullets + 2)"
            :class="{ active: bullets + 2 == pagination }"
          >
          </span>
          <span
            class="pagination"
            @click="changePage(bullets + 3)"
            :class="{
              active: bullets + 3 == pagination,
              sbullet: bullets + 3 < items - 2,
            }"
          >
          </span>
          <span
            class="pagination"
            @click="changePage(bullets + 4)"
            :class="{
              active: bullets + 4 == pagination,
              xsbullet: bullets + 4 < items - 1,
            }"
          >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["paramsMovies"]),
  props: {
    items: { type: Number },
    pagination: { type: Number },
    k: { type: String },
  },
  data: () => ({
    page: "",
    bullets: 0,
  }),
  created() {
    this.page = this.items;
  },
  watch: {
    pagination() {
      if (this.items > 5) {
        if (this.pagination == 0) this.bullets = 0;
        else if (this.pagination == 1) this.bullets = 0;
        else if (this.pagination == this.items - 2)
          this.bullets = this.pagination - 3;
        else if (this.pagination == this.items - 1)
          this.bullets = this.pagination - 4;
        else this.bullets = this.pagination - 2;
      }
    },
    items() {
      this.page = this.items;
      if (this.items > 5) this.page = 5;
    },
  },
  methods: {
    changePage(id) {
      let params = { id: id, key: this.k };
      document.getElementById(this.k).scrollIntoView();
      this.$store.dispatch("FETCH_MOVIES_PAGINATION", params);
    },
  },
};
</script>

<style scoped>
.pagination-wrapper {
  height: 100%;
  padding-top: 20px;
}
.content {
  display: grid;
  grid-template-columns: auto;
  justify-content: space-around;
}
.pagination {
  display: inline-block;
  position: relative;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  margin: 0 7px;
}
.xsbullet {
  width: 10px;
  height: 10px;
}
.sbullet {
  width: 12px;
  height: 12px;
}

.pagination:before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  background: #939292;
  border-radius: 50%;
}

.active:before {
  background: white;
}
.pagination:hover:before {
  background: white;
}
</style>
